
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { useEffect, useState } from 'react';
import { getPowerBIActionDashboardData } from '../../redux/actions/LTPlanner/PowerBIActionDashboardSlice';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Loader } from '../../components/common/Loader';

const AdoptionMetricsPBI = () => {
    const dispatch = useDispatch();
    const ActionDashboardSlice = useSelector((state) => state?.ActionDashboardSlice);
    const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
    const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
    const [powerBIReportID, setPowerBIReportID] = useState("");


    //TODO
    const group_id = process.env.REACT_APP_PBI_ACTION_DASHBOARD_GROUP_ID;
    const report_id = process.env.REACT_APP_PBI_LT_ADOPTION_METRICS_REPORT_ID;

    useEffect(() => {
        const getPowerBIActionDashboardDetails = async () => {
            try {
                const responsePowerBIAdoptionMetrics = await dispatch(getPowerBIActionDashboardData({
                    dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
                    params: {
                        plant: localStorage.getItem("selectedLTPlantCode")
                    }
                }));
                if (responsePowerBIAdoptionMetrics?.meta?.requestStatus === 'fulfilled') {
                    setPowerBIEmbedURL(responsePowerBIAdoptionMetrics?.payload?.embedUrl);
                    setPowerBIReportID(responsePowerBIAdoptionMetrics?.payload?.reportId);
                    setPowerBIAccessToken(responsePowerBIAdoptionMetrics?.payload?.accessToken)
                } else {
                    toast.error(responsePowerBIAdoptionMetrics?.payload?.errorMessage, {
                        autoClose: 2000,
                    });
                }
            } catch (error) {
                console.error('API error:', error);
                toast.error(error, {
                    autoClose: 2000,
                });
            }
        }
        getPowerBIActionDashboardDetails();

    }, []);
    const embedConfig = {
        type: 'report',
        id: powerBIReportID,
        embedUrl: `${powerBIEmbedURL}`,
        accessToken: powerBIAccessToken,
        tokenType: models.TokenType.Embed,
        settings: {
            panes: {
                filters: {
                    expanded: false,
                    visible: false,
                },
            },
            navContentPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth,
            },
        }
    }
    return (
        ActionDashboardSlice?.loading ?
            <Loader />
            :
            <div>
                <div className="powerBi_cls">
                    {embedConfig?.embedUrl && embedConfig?.accessToken &&
                        <PowerBIEmbed
                            embedConfig={embedConfig}
                        />}
                </div>
            </div>
    )
}

export default AdoptionMetricsPBI;